// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGuestUpdateBody = {
  poolId: string;
  guestId: string;
  firstName?: string;
  lastName?: string;
  initials?: string;
};

export type typeSquaresGuestUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    guest: {
      guestId: string;
      firstName: string;
      lastName: string;
      initials: string;
      displayName: string;
    };
  };
};

export type typeSquaresGuestUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGuestUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGuestUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGuestUpdateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    guestId: { type: "string", maxLength: 3000, minLength: 1 },
    firstName: { type: "string", maxLength: 3000, minLength: 1 },
    lastName: { type: "string", maxLength: 3000, minLength: 1 },
    initials: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "guestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGuestUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGuestUpdateBody);
  }

  return async function postSquaresGuestUpdate(
    payload: typeSquaresGuestUpdateBody,
  ): Promise<
    typeSquaresGuestUpdateOutput200 | typeSquaresGuestUpdateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGuestUpdate" failed before calling the network. #21ddd3d5ffea`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#21ddd3d5ffea" },
        },
        data: null,
      } as typeSquaresGuestUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/guest-update`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGuestUpdateOutput200 | typeSquaresGuestUpdateOutput400;
  };
}
